// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__IuqWA","headerIcon":"header_headerIcon__3HpNw","headerText":"header_headerText__36TmX"};